/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Session, SupabaseClient, createClient } from '@supabase/supabase-js';
import { environment } from '../../../environments/environment';
import { SupabaseCore } from '@app-libs/core';

@Injectable({
  providedIn: 'root',
})
export class SupabaseClientService extends SupabaseCore {
  constructor() {
    super({
      SUPABASE_URL: environment.SUPABASE_URL,
      SUPABASE_KEY: environment.SUPABASE_KEY,
      IS_SERVER: false,
    });
    this.supabase = this.getClient();
  }
}
